import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'
import { useFormattingContext } from '../../organisms/FormattingProvider/FormattingContext'
import DenaliActionMenu from '../../organisms/DenaliActionPipeline/triggers/DenaliActionMenu'

/**
 * Represents an individual activity item that should look like a "task"
 * @param activity
 * @param onClick
 * @param className
 * @param style
 * @param includeDueDate - whether to include the due date below the subject
 * @returns {JSX.Element}
 * @constructor
 */
function TaskActivity ({ activity, onClick, includeDueDate, actions, className, style }) {
  const { formatter } = useFormattingContext()

  if (!activity) return null

  return (
    <div className={clsx(className, 'flex flex-row gap-sm')} style={style}>
      <div className='flex flex-row gap-sm clickable flex-1' onClick={onClick}>
        <div>
          <Icon
            name={activity.completed ? 'checkCircle' : 'clock'}
            style={{ fill: activity.completed ? 'var(--color-success-500)' : 'var(--color-warning-500)' }}
            customSize={20}
          />
        </div>
        <div className='flex flex-col gap-xs flex-1'>
          <span>{activity.subject}</span>
          {includeDueDate && activity.endDate && (
            <span className='font-size-xs text-neutral-500'>
              Due {formatter(activity.endDate, 'date')}
            </span>
          )}
        </div>
      </div>
      {actions?.length ? (
        <DenaliActionMenu actions={actions} subject={activity} />
      ) : null}
    </div>
  )
}

TaskActivity.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.any,
    subject: PropTypes.string,
    completed: PropTypes.bool,
    endDate: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  includeDueDate: PropTypes.bool,
  actions: PropTypes.array,
  className: PropTypes.string,
  style: PropTypes.object
}

export default TaskActivity
